"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadFormData = exports.LeadFormCustomerInformation = exports.LeadFormAddress = exports.OrganizationDetails = exports.EmobilityPersonalDetails = exports.LeadFormProposition = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const ChargeStationDetails_1 = require("./ChargeStationDetails");
const Consents_1 = require("./Consents");
const PaymentDetails_1 = require("./PaymentDetails");
const SalesPartnerLead_1 = require("./SalesPartnerLead");
const ChargeCardType_1 = require("./enums/ChargeCardType");
const ChargingStationType_1 = require("./enums/ChargingStationType");
const ChargingStationColor_1 = require("./enums/ChargingStationColor");
const CustomerScenario_1 = require("./enums/CustomerScenario");
const gender_1 = tslib_1.__importDefault(require("./enums/gender"));
const mount_type_1 = tslib_1.__importDefault(require("./enums/mount-type"));
const productSelection_1 = tslib_1.__importDefault(require("./enums/productSelection"));
class LeadFormProposition extends base_models_1.Serializable {
}
exports.LeadFormProposition = LeadFormProposition;
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)(productSelection_1.default),
    (0, base_models_1.Docs)({
        example: 'particulier-laden',
        description: 'The selected proposition',
    }),
    (0, class_transformer_1.Expose)({ name: 'proposition_id' }),
    tslib_1.__metadata("design:type", String)
], LeadFormProposition.prototype, "propositionId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(ChargeCardType_1.ChargeCardType),
    (0, base_models_1.Docs)({
        example: ChargeCardType_1.ChargeCardType.ChargeCard,
        description: `The charge card type`,
    }),
    (0, class_transformer_1.Expose)({ name: 'charge_card_type' }),
    tslib_1.__metadata("design:type", String)
], LeadFormProposition.prototype, "chargeCardType", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: 's-line',
        description: `The model identifier of the charging station`,
    }),
    (0, class_transformer_1.Expose)({ name: 'charging_station_model' }),
    tslib_1.__metadata("design:type", String)
], LeadFormProposition.prototype, "chargingStationModel", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(mount_type_1.default),
    (0, base_models_1.Docs)({
        example: mount_type_1.default.Pole,
        description: `The mount type of the charging station`,
    }),
    (0, class_transformer_1.Expose)({ name: 'mount_type' }),
    tslib_1.__metadata("design:type", String)
], LeadFormProposition.prototype, "mountType", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({ example: true, description: `Does this order include a charge card order` }),
    (0, class_transformer_1.Expose)({ name: 'charge_card' }),
    tslib_1.__metadata("design:type", Boolean)
], LeadFormProposition.prototype, "chargeCard", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(1),
    (0, base_models_1.Docs)({ example: '1234567890', description: `The product ID` }),
    tslib_1.__metadata("design:type", String)
], LeadFormProposition.prototype, "productId", void 0);
class EmobilityPersonalDetails extends base_models_1.Serializable {
}
exports.EmobilityPersonalDetails = EmobilityPersonalDetails;
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)(gender_1.default),
    (0, base_models_1.Docs)({
        example: gender_1.default.OTHER,
        description: 'Gender of the customer to allow us to define how to address the customer',
    }),
    tslib_1.__metadata("design:type", String)
], EmobilityPersonalDetails.prototype, "salutation", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'W.B.', description: `Customer's initials` }),
    tslib_1.__metadata("design:type", String)
], EmobilityPersonalDetails.prototype, "initials", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'van der', description: `Prefix to the customer's last name (Dutch)` }),
    tslib_1.__metadata("design:type", String)
], EmobilityPersonalDetails.prototype, "prefix", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)({ name: 'last_name' }),
    (0, base_models_1.Docs)({ example: 'Boom', description: `Customer's last name` }),
    tslib_1.__metadata("design:type", String)
], EmobilityPersonalDetails.prototype, "lastName", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsPhoneNumber)('NL'),
    (0, class_transformer_1.Expose)({ name: 'phone_number' }),
    (0, base_models_1.Docs)({ example: '06-12345789', description: 'Phone number' }),
    tslib_1.__metadata("design:type", String)
], EmobilityPersonalDetails.prototype, "phoneNumber", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEmail)(),
    (0, class_transformer_1.Expose)({ name: 'email_address' }),
    (0, base_models_1.Docs)({ example: 'w.boom@example.com', description: 'E-mail address' }),
    tslib_1.__metadata("design:type", String)
], EmobilityPersonalDetails.prototype, "emailAddress", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({ description: 'date of birth', example: '1990-12-31' }),
    (0, class_transformer_1.Expose)({ name: 'date_of_birth' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], EmobilityPersonalDetails.prototype, "dateofBirth", void 0);
class OrganizationDetails extends base_models_1.Serializable {
}
exports.OrganizationDetails = OrganizationDetails;
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'Essent B.V.', description: `Organization name` }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], OrganizationDetails.prototype, "organizationName", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.Length)(8),
    (0, base_models_1.Docs)({ example: '17115973', description: `Chamber of commerce number` }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], OrganizationDetails.prototype, "chamberOfCommerceNumber", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(CustomerScenario_1.CustomerScenario),
    (0, base_models_1.Docs)({ example: CustomerScenario_1.CustomerScenario.ExistingConsumer, description: `The customer scenario` }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], OrganizationDetails.prototype, "customerScenario", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({ example: false, description: `Whether the customer is interested in reimbursement` }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", Boolean)
], OrganizationDetails.prototype, "interestedInReimbursement", void 0);
class LeadFormAddress extends base_models_1.Serializable {
}
exports.LeadFormAddress = LeadFormAddress;
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsPostalCode)('NL'),
    (0, base_models_1.Docs)({ example: '5211 AK', description: 'Postal code' }),
    (0, class_transformer_1.Expose)({ name: 'postal_code' }),
    tslib_1.__metadata("design:type", String)
], LeadFormAddress.prototype, "postalCode", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)({ name: 'house_number' }),
    (0, base_models_1.Docs)({ example: 4, description: 'House number' }),
    tslib_1.__metadata("design:type", Number)
], LeadFormAddress.prototype, "houseNumber", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)({ name: 'house_number_addition' }),
    (0, base_models_1.Docs)({ example: 'A', description: 'Addition to house number' }),
    tslib_1.__metadata("design:type", String)
], LeadFormAddress.prototype, "houseNumberAddition", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'Willemsplein', description: 'Street name' }),
    tslib_1.__metadata("design:type", String)
], LeadFormAddress.prototype, "street", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: `'s-Hertogenbosch`, description: 'City, town or village name' }),
    tslib_1.__metadata("design:type", String)
], LeadFormAddress.prototype, "city", void 0);
class LeadFormCustomerInformation extends base_models_1.Serializable {
}
exports.LeadFormCustomerInformation = LeadFormCustomerInformation;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({ example: base_models_1.SegmentType.HH, description: 'Requested segment' }),
    (0, class_validator_1.IsIn)([base_models_1.SegmentType.HH, base_models_1.SegmentType.SOHO]),
    tslib_1.__metadata("design:type", String)
], LeadFormCustomerInformation.prototype, "requestedSegmentType", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({ example: base_models_1.SegmentType.HH, description: 'Requested segment' }),
    (0, class_validator_1.IsIn)([base_models_1.SegmentType.HH, base_models_1.SegmentType.SOHO]),
    tslib_1.__metadata("design:type", String)
], LeadFormCustomerInformation.prototype, "currentSegmentType", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({ example: true, description: 'Whether customer has charge cards' }),
    tslib_1.__metadata("design:type", Boolean)
], LeadFormCustomerInformation.prototype, "hasChargeCard", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({ example: true, description: 'Whether customer has a charging station' }),
    tslib_1.__metadata("design:type", Boolean)
], LeadFormCustomerInformation.prototype, "hasChargeStation", void 0);
class LeadFormData extends base_models_1.Serializable {
}
exports.LeadFormData = LeadFormData;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '01J35DAS90Z1HS1Q2WVA90KB1R', description: 'verificationCode' }),
    (0, class_transformer_1.Expose)({ name: 'verification_code' }),
    tslib_1.__metadata("design:type", String)
], LeadFormData.prototype, "verificationCode", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => LeadFormProposition),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.Docs)({ example: {}, description: 'information about the proposition' }),
    (0, class_transformer_1.Expose)({ name: 'proposition' }),
    tslib_1.__metadata("design:type", LeadFormProposition)
], LeadFormData.prototype, "proposition", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => ChargeStationDetails_1.EmobilityChargeStationDetails),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.Docs)({
        example: {
            type: ChargingStationType_1.ChargingStationType.ProLine,
            color: ChargingStationColor_1.ChargingStationColor.White,
            fixedCable: false,
            mountType: mount_type_1.default.Pole,
            interestedInReimbursement: true,
        },
        description: 'information about the charge point',
    }),
    (0, class_transformer_1.Expose)({ name: 'charge_station_details' }),
    tslib_1.__metadata("design:type", ChargeStationDetails_1.EmobilityChargeStationDetails)
], LeadFormData.prototype, "chargeStationDetails", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => EmobilityPersonalDetails),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.Docs)({ example: {}, description: 'personal details' }),
    (0, class_transformer_1.Expose)({ name: 'personal_details' }),
    tslib_1.__metadata("design:type", EmobilityPersonalDetails)
], LeadFormData.prototype, "personalDetails", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => OrganizationDetails),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.Docs)({ example: {}, description: 'organization details' }),
    (0, class_transformer_1.Expose)({ name: 'organization_details' }),
    tslib_1.__metadata("design:type", OrganizationDetails)
], LeadFormData.prototype, "organizationDetails", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => LeadFormAddress),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.Docs)({ example: {}, description: 'installation address' }),
    (0, class_transformer_1.Expose)({ name: 'installation_address' }),
    tslib_1.__metadata("design:type", LeadFormAddress)
], LeadFormData.prototype, "installationAddress", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => LeadFormAddress),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.Docs)({ example: {}, description: 'correspondence address' }),
    (0, class_transformer_1.Expose)({ name: 'correspondence_address' }),
    tslib_1.__metadata("design:type", LeadFormAddress)
], LeadFormData.prototype, "correspondenceAddress", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => PaymentDetails_1.LeadFormPaymentDetails),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.Docs)({
        example: {},
        description: 'payment details',
    }),
    (0, class_transformer_1.Expose)({ name: 'payment_details' }),
    tslib_1.__metadata("design:type", PaymentDetails_1.LeadFormPaymentDetails)
], LeadFormData.prototype, "paymentDetails", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => base_models_1.ContactLog),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.Docs)({
        example: {},
        description: 'contactlog',
    }),
    (0, class_transformer_1.Expose)({ name: 'contact_log' }),
    tslib_1.__metadata("design:type", base_models_1.ContactLog)
], LeadFormData.prototype, "contactLog", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Consents_1.Consents),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.Docs)({
        example: {
            acceptedCallFromAdvisor: true,
            acceptedPaymentConditions: false,
            acceptedTermsAndConditions: false,
            acceptedTariffRateChange: true,
            acceptedProductMail: true,
        },
        description: 'Customer consents',
    }),
    tslib_1.__metadata("design:type", Consents_1.Consents)
], LeadFormData.prototype, "consents", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => LeadFormCustomerInformation),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({
        example: {
            requestedSegmentType: base_models_1.SegmentType.HH,
            currentSegmentType: base_models_1.SegmentType.SOHO,
            hasChargeCard: true,
            hasChargeStation: false,
        },
        description: 'Customer information',
    }),
    tslib_1.__metadata("design:type", LeadFormCustomerInformation)
], LeadFormData.prototype, "customerInformation", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({
        example: '1234567890',
        description: 'Campaign ID',
    }),
    tslib_1.__metadata("design:type", String)
], LeadFormData.prototype, "campaignId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({
        example: '1234567890',
        description: 'External partner ID',
    }),
    tslib_1.__metadata("design:type", String)
], LeadFormData.prototype, "externalPartnerId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => SalesPartnerLead_1.SalesPartnerLeadData),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.Docs)({
        example: {
            employee: 'J. Jansen',
            channel: 'EV',
            service_partner: 'Essent',
            store: 'Essent Zwolle',
            product_type: 'EV',
            campaign: 'EV Voorjaar campagne 2024',
            registration_date: '2021-06-01',
        },
        description: 'Additional data, expected values will be provided',
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", SalesPartnerLead_1.SalesPartnerLeadData)
], LeadFormData.prototype, "requestContext", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({
        example: 'ESC_1234567',
        description: 'E2E Tracking ID for Adobe Launch',
    }),
    tslib_1.__metadata("design:type", String)
], LeadFormData.prototype, "e2eTrackingId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({
        example: 'morning',
        description: 'Preferred callback moment',
    }),
    tslib_1.__metadata("design:type", String)
], LeadFormData.prototype, "callbackMoment", void 0);
